<script setup lang="ts">
interface StatusConfig {
  color: string;
  icon: string;
}

const statusMap: Record<string, StatusConfig> = {
  Draft: { color: 'info', icon: 'mdi-pencil-outline' },
  'Pending Review': { color: 'warning', icon: 'mdi-clock-outline' },
  Approved: { color: 'success', icon: 'mdi-check-decagram' },
  Fundraising: { color: 'primary', icon: 'mdi-hand-heart' },
  'Processing payments': { color: 'primary', icon: 'mdi-progress-clock' },
  Confirmed: { color: 'tertiary', icon: 'mdi-check-circle' },
  'In Progress': { color: 'secondary', icon: 'mdi-play-circle' },
  Completed: { color: 'success', icon: 'mdi-flag-checkered' },
  Canceled: { color: 'error', icon: 'mdi-cancel' },
  Failed: { color: 'error', icon: 'mdi-alert-circle' },
  Denied: { color: 'error', icon: 'mdi-close-circle' },
  'Did Not Fund': { color: 'error', icon: 'mdi-alert-circle' },
};

const fallback: StatusConfig = {
  color: 'surface-variant',
  icon: 'mdi-help-circle',
};

type ChipVariant =
  | 'flat'
  | 'text'
  | 'elevated'
  | 'tonal'
  | 'outlined'
  | 'plain';

const props = withDefaults(
  defineProps<{
    status: string;
    variant?: ChipVariant;
  }>(),
  { variant: 'tonal' },
);

const config = computed(() => statusMap[props.status] ?? fallback);
</script>

<template>
  <v-chip
    :color="config.color"
    :prepend-icon="config.icon"
    :variant="variant"
    size="small"
    label
  >
    {{ status }}
  </v-chip>
</template>
